<template>
  <div v-loading="loading">
    <div class="container-fluid py-4">
      <div class="row">
        <DashboardBilletTotalColumn title="Total de Objetos" :data="dashboardData.quantity" icon="ni-money-coins"
          color="bg-gradient-primary" />
        <DashboardBilletTotalColumn title="Total Fatura" :data="money(dashboardData.total)" icon="ni-world"
          color="bg-gradient-info" />
        <DashboardBilletTotalColumn title="Créditos" :data="money(dashboardData.credit)" icon="ni-check-bold"
          color="bg-gradient-orange" />
        <DashboardBilletTotalColumn title="Débitos" :data="money(dashboardData.debit)" icon="ni-basket"
          color="bg-gradient-indigo" />
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/plugin/i18n";
import { DashboardService } from "@/services/customers/dashboard.services";
import DashboardBilletTotalColumn from './DashboardBilletTotalColumn';

export default {
  name: "DashboardBilletTotal",
  components: {
    DashboardBilletTotalColumn,
  },
  props: ["month"],
  data() {
    return {
      loading: false,
      dashboardData: {
        charges: 0,
        complement: 0,
        credit: 0,
        debit: 0,
        discount: 0,
        financial: 0,
        quantity: 0,
        servicesActual: 0,
        servicesPrevious: 0,
        total: 0,
        value: 0,
      },
    };
  },
  methods: {
    money(value) {
      return Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(value);
    },
    fetch() {
      const vm = this;
      vm.tableData = [];
      vm.loading = true;
      DashboardService.total(vm.month)
        .then((response) => {
          console.log('response', response)
          vm.dashboardData = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => vm.loading = false);
    },
  },
};
</script>
